import React, { useEffect, useState } from "react";
import Navbar from "../Navbar";
import Sidebar from "../Sidebar";
import axios from "axios";
import Config from "../Config";
import Cookies from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import Toastmodal from "../Toastmodal";
import { useAuthHandling } from '../useAuthhandling';
import Allimagestyle from "../Blog/Allimage_style";
import Allimageselect from "../Blog/Allimageselect";
import Select from 'react-select';

function Projectadd() {
  const { isAuthorized, handleUnauthorized } = useAuthHandling();

  let navigate = useNavigate();
  const [toastmodal, setToastmodal] = useState(false);
  const [toastmessage, setToastmessage] = useState("");
  const [toasttype, setToasttype] = useState("");
  const [toastlarge, setToastlarge] = useState(false);
  const [selectedImageId, setSelectedImageId] = useState([]);
  const [uploadedImages, setUploadedImages] = useState([]);
  const tokens = Cookies.get("a_token");
  if (!tokens) {
    navigate("/");
  }
  const [service, setService] = useState({
    projectName: "",
    projectStatus: "",
    location: "",
    professional: "",
    customer: "",
    startDate: "",
    endDate: "",
    projectImage: [],
  });
  const [formerror, setError] = useState({});
  const [cust, setCust] = useState([]);
  const [useroption,setUseroption]=useState([]);
  const [selecteduser,setSelecteduser]=useState([]);

  const [prof, setProf] = useState([]);
  const [profoption, setProfoption] = useState([]);
  const [selectedprof, setSelectedprof] = useState([]);

  const getprof = async (e) => {
    const res = await fetch(
      `${Config.apiurl}/api/v1/data/professionals-dropdown`,
      {
        method: "GET",
      }
    );

    const data1 = await res.json();
    const data = data1.data;
    if (res.status === 404 || !data) {
      toast.error("error!", {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      setProf(data);
    }
  };

  const getcust = async (e) => {
    const res = await fetch(
      `${Config.apiurl}/api/v1/crm/customer/get-customers-dropdown`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );

    if (res.status === 200) {
      const data1 = await res.json();
      const data = data1.data;
      setCust(data);
    }
    else if(res.status === 401){
      handleUnauthorized();
      getcust();
    }
    else {
      toast.error("error!", {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  let name, value;
  const handleInputs = (e) => {
    console.log(e);
    name = e.target.name;
    value = e.target.value;
    setService({ ...service, [name]: value });
  };

  const onFileChange = (e) => {
    console.log(e);
    let name = e.target.name;
    setService({ ...service, [name]: e.target.files });
  };
  const validate = (values) => {
    const errors = {};
    if (!values.projectName) {
      errors.projectName = "Name is required!";
    }

    if (!values.projectStatus) {
      errors.projectStatus = "Status is required!";
    }
    if (!values.location) {
      errors.location = "Location is required!";
    }
    if (!selectedprof?.value) {
      errors.professional = "Professional is required!";
    }
    if (!selecteduser?.value) {
      errors.customer = "Customer is required!";
    }
    if (!values.startDate) {
      errors.startDate = "Start date is required!";
    }
    if (!values.endDate) {
      errors.endDate = "End date is required!";
    }
    if (selectedImageId.length===0) {
      errors.projectImage = "Image is required!";
    } 
    // if (!values.projectImage) {
    //   errors.projectImage = "Image is required!";
    // } else {
    //   for (var i = 0; i < values.projectImage.length; i++) {
    //     if (
    //       values.projectImage[i].type === "image/jpeg" ||
    //       values.projectImage[i].type === "image/jpg" ||
    //       values.projectImage[i].type === "image/png"
    //     ) {
    //       if (values.projectImage[i].size > 1024 * 1000) {
    //         errors.projectImage =
    //           "maximum file size 1 mb...please upload an image less than 1 mb";
    //       }
    //     } else {
    //       errors.projectImage = "Only support jpg, jpeg, png image!";
    //     }
    //   }
    // }

    return errors;
  };

  const PostData = async (e) => {
    e.preventDefault();
    const {
      projectName,
      projectStatus,
      location,
      professional,
      customer,
      startDate,
      endDate,
      projectImage,
    } = service;
    const ress = validate(service);
    setError(ress);
    if (
      !ress.projectName &&
      !ress.projectStatus &&
      !ress.location &&
      !ress.customer &&
      !ress.professional &&
      !ress.startDate &&
      !ress.endDate &&
      !ress.projectImage
    ) {
      // const formData = new FormData();
      // formData.append("projectName", service.projectName);
      // formData.append("projectStatus", service.projectStatus);
      // formData.append("location", service.location);
      // formData.append("professional", service.professional);
      // formData.append("customer", service.customer);
      // formData.append("startDate", service.startDate);
      // formData.append("endDate", service.endDate);
      // for (var x = 0; x < service.projectImage.length; x++) {
      //   formData.append("projectImage", service.projectImage[x]);
      // }

      const data = {
        projectName: service.projectName,
        projectStatus:service.projectStatus,
        project_images: selectedImageId.map((img) => img.id),
        location:  service.location,
        professional:selectedprof?.value,
        customer:selecteduser?.value,
        startDate:service.startDate,
        endDate: service.endDate,
      };
      axios
        .post(`${Config.apiurl}/api/v1/crm/project/create`, data, {
          headers: {
            Authorization: `Bearer ${Cookies.get("a_token")}`,
          },
        })
        .then((res) => {
          if (res.status === 200) {
            setToastmodal(true);
            setToastmessage("Sucessfully Created Project");
            setToasttype("success");
            setToastlarge(false);
            setTimeout(() => navigate("/dashboard"), 3000);
          }
          else if(res.status === 401){
            handleUnauthorized();
            PostData();
          }
          else {
            setToastmodal(true);
            setToastmessage(res.message);
            setToasttype("error");
          }
        });
    }
  };
  useEffect(() => {
    getprof();
    getcust();
  }, []);

  useEffect(()=>{
    const options = cust.map(item => ({ value: item?._id, label: item?.name }));
    setUseroption(options);
  },[cust])

  useEffect(()=>{
    const options = prof.map(item => ({ value: item?._id, label: item?.name }));
    setProfoption(options);
  },[prof])

  return (
    <>
      <div className="container-scroller">
        <Navbar />
        <div className="container-fluid page-body-wrapper">
          <Sidebar />
          <div className="main-panel">
            <div className="content-wrapper">
              <div className="row grid-margin">
                <div className="col-12">
                  <div className="card">
                    <div className="card-body">
                      <h4 className="card-title">Project Table</h4>
                      <form className="forms-sample" onSubmit={PostData}>
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">
                            Project name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="Project Name"
                            name="projectName"
                            value={service.projectName}
                            onChange={handleInputs}
                          />
                          <label style={{ color: "red" }}>
                            {formerror.projectName}
                          </label>
                        </div>
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">Status</label>
                          <input
                            type="text"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="Project Status"
                            name="projectStatus"
                            value={service.projectStatus}
                            onChange={handleInputs}
                          />
                          <label style={{ color: "red" }}>
                            {formerror.projectStatus}
                          </label>
                        </div>
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">
                            location
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="Location"
                            name="location"
                            value={service.location}
                            onChange={handleInputs}
                          />
                          <label style={{ color: "red" }}>
                            {formerror.location}
                          </label>
                        </div>
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">
                            Professional
                          </label>
                          {/* <select
                            id="professional"
                            className="form-control"
                            name="professional"
                            onChange={handleInputs}
                            style={{ color: "black" }}
                          >
                            <option>Select</option>
                            {prof.map((element) => {
                              return (
                                <option name="professional" value={element._id}>
                                  {element.name}
                                </option>
                              );
                            })}
                          </select> */}
                          <Select             
                            options={profoption}
                            isSearchable={true}
                            className="my-select"
                            value={selectedprof}
                            onChange={setSelectedprof}
                            // placeholder="Select the number of bedrooms"
                            />
                          <label style={{ color: "red" }}>
                            {formerror.professional}
                          </label>
                        </div>
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">
                            customer
                          </label>
                          <Select 
                            options={useroption}
                            isSearchable={true}
                            value={selecteduser}
                            className="my-select"
                            onChange={setSelecteduser}
                            // placeholder="Select the number of bedrooms"
                            />
                          {/* <select
                            id="customer"
                            className="form-control"
                            name="customer"
                            onChange={handleInputs}
                            style={{ color: "black" }}
                          >
                            <option>Select</option>
                            {cust.map((element) => {
                              return (
                                <option name="customer" value={element._id}>
                                  {element.name}
                                </option>
                              );
                            })}
                          </select> */}
                          <label style={{ color: "red" }}>
                            {formerror.customer}
                          </label>
                        </div>
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">
                            Start Date
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="projectStatus"
                            name="startDate"
                            value={service.startDate}
                            onChange={handleInputs}
                            onClick={(e) => e.target.showPicker()}
                          />
                          <label style={{ color: "red" }}>
                            {formerror.startDate}
                          </label>
                        </div>
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">
                            End Date
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="projectStatus"
                            name="endDate"
                            value={service.endDate}
                            onChange={handleInputs}
                            onClick={(e) => e.target.showPicker()}
                          />
                          <label style={{ color: "red" }}>
                            {formerror.endDate}
                          </label>
                        </div>

                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1">
                            Image (500px * 343px)
                          </label>
                          <br></br>

                          <Allimagestyle selectedImageId={selectedImageId} setSelectedImageId ={setSelectedImageId}  uploadedImages={uploadedImages} setUploadedImages={setUploadedImages}/>


                          {/* <input
                            type="file"
                            name="projectImage"
                            onChange={onFileChange}
                            multiple
                          /> */}
                         
                         <Allimageselect selectedImageId={selectedImageId} setSelectedImageId ={setSelectedImageId}  uploadedImages={uploadedImages} setUploadedImages={setUploadedImages}/>

                      <label style={{ color: "red" }}>
                        {formerror.projectImage}
                      </label>
                        </div>

                        <button
                          type="submit"
                          onClick={PostData}
                          className="btn btn-primary me-2"
                        >
                          Submit
                        </button>
                        <ToastContainer />
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {toastmodal ? (
        <Toastmodal
          setToast={setToastmodal}
          message={toastmessage}
          type={toasttype}
          large={toastlarge}
        />
      ) : (
        ""
      )}
    </>
  );
}
export default Projectadd;
